import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { useServiceModeContext } from 'state/service-mode';
import { useUIContext } from 'state/ui';
import { isCatering } from 'utils/service-mode';

interface ILimitMessageProps {
  limit: number;
}

const MutedText = styled.div`
  text-align: center;
  color: ${Styles.color.grey.one};
  font-size: 0.8rem;
  padding-bottom: 1rem;
`;

const LimitMessage: React.FC<ILimitMessageProps> = ({ limit }) => {
  const { formatMessage } = useIntl();
  const { formatCurrencyForLocale } = useUIContext();
  const { serviceMode } = useServiceModeContext();
  const isCateringOrder = isCatering(serviceMode);

  if (isCateringOrder) {
    return null;
  }

  return (
    <MutedText>
      {formatMessage(
        { id: 'orderLimitWarningX' },
        {
          limit: formatCurrencyForLocale(limit),
        }
      )}
    </MutedText>
  );
};

export default LimitMessage;
